import OrderForm from '../components/OrderForm';

const Checkout = ():JSX.Element => {
    return (
        <>
            <OrderForm />
        </>
    );
}

export default Checkout;